<!-- 我的　用品請領單　 -->

<template>
  <div>
    <el-row :gutter="20" class="top-block">
      <Breadcrumb :route="this.$route"></Breadcrumb>
  　</el-row>
    

    <el-row class="ml-20 mr-20"  v-if="!editMode">
        <el-col :xs="8" :sm="8" :lg="8">
          <el-button icon="el-icon-search" circle type="warning" @click="drawer = true"></el-button>
        </el-col>
        <el-col :xs="16" :sm="16" :lg="16" >
          <el-button type="primary" @click.prevent="createItem" style="float: right">新增 <i class="el-icon-circle-plus-outline"></i>
          </el-button>
          <el-button type="primary" @click.prevent="dialogImportFormVisible = true" style="float: right; margin-right: 10px;">匯入 <i class="el-icon-download"></i>
          </el-button>
          
        </el-col>
    </el-row >


    <el-row class="ml-20 mr-20" v-if="!editMode">
      <!-- <el-col :xs="24" :sm="24" :lg="6">
          <el-main>
            <el-table :data="groupByTableData"
                      default-expand-all
                      row-key="id"
                      empty-text="無資料"
                      stripe header-row-class-name="headerStyle">
              <el-table-column label="地區">
                <template slot-scope="scope">
                  <el-button type="text" @click.prevent="searchTerm(scope.row.col)"> {{scope.row.col}} ({{scope.row.count}})</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-main>
        </el-col> -->

      <el-col :xs="24" :sm="24" :lg="24">
          <el-main>
            <el-table id="item_table" :data="tableData" empty-text="無資料" stripe header-row-class-name="headerStyle">
              <el-table-column prop="area" label="地區" v-if="canViewAll === 'Y'">
              </el-table-column>
              <el-table-column prop="itemTypeLabel" label="類型" >
              </el-table-column>
              <el-table-column prop="itemName" label="名稱" >
              </el-table-column>
              
              <el-table-column prop="stock" label="目前數量" >
              </el-table-column>
              <el-table-column label="操作" width="300">
                <template slot-scope="scope">
                  <el-button type="warning" @click="handleEdit(scope.row)">編輯 <i class="el-icon-edit"></i></el-button>
                  <el-popconfirm
                      class="ml-10 popconfirm-bg"
                      title="確定刪除此筆資料嗎?"
                      confirm-button-text="確定"
                      cancel-button-text="取消刪除"
                      icon="el-iconf-info"
                      icon-color="red"
                      @confirm="handleDelete(scope.row.id)"
                  >
                    <el-button type="danger" slot="reference">刪除 <i class="el-icon-delete"></i></el-button>
                  </el-popconfirm>
                </template>
              </el-table-column>
            </el-table>

            <div style="border-radius:8px; margin-top:10px;padding:20px 10px; text-align: center; background-color: white">
              <el-pagination
                  background
                  layout="prev, pager, next"
                  :current-page="pageNum"
                  :page-size="pageSize"
                  :total="total"
                  @current-change="handleCurrentChange">
              </el-pagination>
            </div>

          </el-main>
        
      </el-col>
    </el-row>

    <el-row class="ml-20 mr-20" v-if="editMode">
      <el-main style="background-color: white;">

        <el-col :xs="24" :sm="24" :lg="24">
          <el-form :model="form" :rules="rules" ref="dataForm" label-position="top">
            <el-form-item label="地區" prop="area">
              <el-select :disabled="true" v-model="form.area" placeholder="選擇地區">
                <el-option v-for="t in areaOptions"
                           :key="t.id"
                           :label="t.label"
                           :value="t.value"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="用品分類" prop="itemType">
              <el-select v-model="form.itemType" placeholder="選擇用品分類">
                <el-option v-for="t in typeOptions"
                           :key="t.id"
                           :label="t.value"
                           :value="t.id"></el-option>
              </el-select>
            </el-form-item>
            
            <el-form-item label="用品名稱" prop="itemName">
              <el-input v-model="form.itemName" autocomplete="off"></el-input>
            </el-form-item>

              
            <div style="float: right;">
              <el-button @click="cancelAdd">取 消</el-button>
              <el-button type="primary" @click="saveData('dataForm')">下一步</el-button>
            </div>
          </el-form>
        </el-col>
      </el-main>
    </el-row>

    
    

      <el-drawer
        size="70%"
        title="搜尋"
        :visible.sync="drawer"
        :direction="direction"
        :before-close="handleClose">
        <div>
            <el-select :xs="24" v-model="queryField" placeholder="選擇搜尋條件" style="padding: 0 0 0 20px">
              <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
            <el-input v-model="keyword" style="width: 200px" placeholder="輸入關鍵字" class="ml-10"
                      suffix-icon="el-icon-search"></el-input>

            <el-button type="primary" @click.prevent="search" class="ml-10">查詢</el-button>
            <el-button type="normal" @click.prevent="clearQuery" class="ml-10">清除條件</el-button>
          </el-col>
        </div>
      </el-drawer>


      <el-dialog title="用品匯入"
                 :visible.sync="dialogImportFormVisible"
                 :width="dw">
        <el-form ref="importForm" label-width="100px">
          <div style="text-align: center;" v-if="loading">
            <i class="el-icon-loading" style="font-size:22px"></i>匯入處理中...
          </div>
          <el-upload drag
                     class="avatar-uploader"
                     :show-file-list="false"
                     :action="importAction"
                     :on-progress="avatarProgress"
                     :on-change="avatarChanged"
                     :on-success="handleImportSuccess"
                     :before-upload="beforeImport">
            <i class="el-icon-plus avatar-uploader-icon"></i>
            <div slot="tip" class="el-upload__tip">限上傳 xlsx、xls 格式</div>
          </el-upload>
        </el-form>
      </el-dialog>

    
  </div>

</template>

<script>
import {mapState} from 'vuex'
import Breadcrumb from "@/components/breadcrumb/Breadcrumb";

export default {
  name: "ItemMaintain",
  components: {
    Breadcrumb
  },
  data() {
    let checkName = (rule, value, callback) => {
      if (value === '' || value === null || typeof value === 'undefined') {
        callback(new Error('請輸入資料'))
      } else {
        callback()
      }
    }

    return {
      dw: '40%',
      dialogImportFormVisible: false,
      loading: false,
      importAction: '',

      groupByTableData:[],

      /** query drawer **/
      drawer: false,
      direction: 'ltr',
      queryField: '',
      keyword: '',

      /** pagination **/
      pageNum: 1,
      pageSize: 15,
      total: 0,
      
      tableData:[],

      /**用品分類下拉選單**/
      typeOptions:[],

      canViewAll:'N',

      areaOptions:[
        {value: '北區', label: '北區'},
        {value: '中區', label: '中區'},
        {value: '南區', label: '南區'}
      ],

      options: [
        {value: 'name', label: '依用品名稱'}
        ],

      /** 是否在編輯模式 **/
      editMode: false,



      
      form: {
        area:'',
        itemType: '',
        itemName: ''
      },
      
      rules: {
        name: [{required: true, validator: checkName, trigger: 'change'}],
        itemType: [{required: true, validator: checkName, trigger: 'change'}],
        area: [{required: true, validator: checkName, trigger: 'change'}],
      }
    }
  },
  methods: {
    cancelAdd() {
      this.$refs['dataForm'].resetFields()
      this.editMode = false
    },
    handleCurrentChange(val){
      this.pageNum = val
      this.loadData()
    },

    handleEdit(rowData){
      this.$router.push('/item/detail/' + rowData.id)
    },
    handleDelete(id) {

      this.request.delete("/item/" + id).then(res => {
          if (res.code === '200') {
            this.loadGroupbyData()
            this.showResult('success', '資料刪除成功.')
          } else {
            this.showResult('error', '資料刪除失敗.')
          }
      })

    },
    handleClose(){
      this.drawer = false
    },
    
    /** data crud **/
    loadData() {
      
      try {

        let {pageNum, pageSize, queryField, keyword} = this

        let url = "/item/page?pageNum=" + pageNum + "&pageSize=" + pageSize + "&queryField=" + queryField + "&keyword=" + keyword 
        
        //console.log('search:', url)
        let q = {
          pageNum,
          pageSize,
          queryField,
          keyword,
        }
        localStorage.setItem('LH_ITEM_QUERY', JSON.stringify(q))

        this.request.get(url).then(res => {
          if (res.code === '200') {
            this.tableData = res.data.records
            this.total = res.data.total
          }
        })



        
      } catch (e) {
        this.tableData = []
        this.total = 0
        this.showResult('error', e.message)
      }

    },

    saveData(formName){
      this.$refs[formName].validate(async valid => {
        if (valid) {
          this.request.post("/item", this.form).then(res => {
            this.$router.push("/item/detail/" + res.data.id)
          })
        }
      })
    },

    createItem(){
      this.editMode = true

    },

    loadTaskType() {
      let req = '/dic/type?queryField=item_type'
      this.request.get(req).then(res => {
        if (res.code === '200') {
          this.typeOptions = res.data
        }
      })
    },
    avatarProgress(){
      this.loading = true
    },
    avatarChanged(){
      this.loading = false
    },
    handleImportSuccess(res, file) {
      this.dialogImportFormVisible = false
      if (res.code === '200') {
        this.showResult('success', '匯入完成')
        this.loadGroupbyData()
      } else {
        this.showResult('error', res.message)
      }
    },
    beforeImport(file) {
      const isExcel = (file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || file.type === 'application/vnd.ms-excel');
      if (!isExcel) {
        this.$message.error('限上傳 xlsx、xls 格式');
      }
      return isExcel
    },

    loadGroupbyData() {
      this.request.get("/item/groupby").then(res => {
        if (res.code === '200') {
          this.groupByTableData = res.data
          this.loadData()
        }
      })
    },
    searchTerm(term){
      this.pageNum = 1
      this.total = 0
      this.queryField = 'area'
      this.keyword = term
      this.loadData()
      
      this.$nextTick(_ => {
        document.getElementById("item_table").scrollIntoView({behavior: 'smooth', inline:'nearest'})
      });
    },
    search() {
      this.drawer = false
      this.pageNum = 1
      this.loadData()
    },
    clearQuery() {
      this.drawer = false

      this.keyword = ''
      this.queryField = ''
      this.pageNum = 1
      let q = {
        pageNum:this.pageNum,
        pageSize:this.pageSize,
        queryField:this.queryField,
        keyword:this.keyword
      }

      localStorage.setItem('LH_ITEM_QUERY', JSON.stringify(q))


      this.loadData()
    },
    userItemViewPermission(){
      this.request.get("/item/view/permission").then(res => {
        if (res.code === '200') {
          this.canViewAll = res.data
        }
      })
    },
    setDialogWidth() {
      let windowSize = document.body.clientWidth;
      console.log('windowSize:', windowSize)
      const defaultWidth = '400'; // 預設寬度
      if (windowSize < defaultWidth) {
        this.dw = "90%";
      } else {
        this.dw = "40%"
      }
    },

  },
  computed: {
    ...mapState('login', ['userInfo']),
  },
  mounted() {
    let cache = localStorage.getItem('LH_ITEM_QUERY')
    let cacheObj = JSON.parse(cache)
    if (cache !== null) {
      this.pageNum = cacheObj.pageNum
      this.pageSize = cacheObj.pageSize
      this.queryField = (typeof cacheObj.queryField === 'undefined')? '': cacheObj.queryField
      this.keyword = (typeof cacheObj.keyword === 'undefined')? '': cacheObj.keyword
    }

    
    this.userItemViewPermission()

    this.form.area = this.userInfo.area

    this.loadTaskType();

    this.importAction = '/api/item/imp?token=' + this.userInfo.token
    

    this.loadGroupbyData()

    this.setDialogWidth()

  }
}
</script>

<style scoped>
  
.avatar-uploader {
  /*border: 1px dashed #d9d9d9;*/
  /*border-radius: 6px;*/
  cursor: pointer;
  position: relative;
  overflow: hidden;
  margin-bottom: 20px;
  text-align: center;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

/deep/ .el-upload-dragger {
  width: 260px !important;
  border: 3px dashed #d9d9d9;
}

</style>
